import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { ShoppingService } from '../../core/services/shopping.service';
// tslint:disable-next-line:max-line-length
import { CreateAccountModel, CountryListModel, ProvinceModel, InstituteListModel, ProgramModel, GraduationYearModel } from '../../core/models/CreateAccount.model';
import { appMessages, appVariables, marketoLeadAccountDetails,invalidZipcodes } from '../../core/constants/Common.constant';
import { HelperService } from '../../core/services/helper.service';
import { UserModel, ShoppingCartModel } from '../../core/models/ShoppingCart.model';
import { environment } from '../../../environments/environment';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EmailAlreadyExistPopupComponent } from '../modals/email-already-exist-popup/email-already-exist-popup.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent implements OnInit, OnDestroy {  //, AfterViewInit
  registrationForm: FormGroup;
  CreateAccountModel: CreateAccountModel;
  CountryList: CountryListModel[];
  InstituteList: InstituteListModel[];
  ShowZip: boolean;
  ShowProvince: boolean;
  ShowOtherInstitute: boolean;
  ShowInstitue: boolean;
  ErrorValue: string;
  SelectedInstitute: string;
  Institute: string;
  ProvinceList: ProvinceModel[];
  Province: string;
  fromLocal: UserModel;
  errorMessage: string;
  errorInstitute: boolean;

  ProgramList: ProgramModel[];
  GraduationList: GraduationYearModel[];
  ProgramID?: number;
  YearsId?: number;
  existingAccount = false;
  ShoppingCart = new ShoppingCartModel();

  ShowError: boolean;
  MsgMismatchEmail: string;
  MsgMismatchPassword: string;
  InvalidEmail: boolean;
  SelectedCountryID?: number;
  emailOption: any = true;
  invalidGraduationYear: string = ``;
  marketoJSObject: any;
  isZipCodeValid = true;
  InvalidZipcodeList:string[] = [];
  private subject = new Subject<any>();
 // @ViewChild('ZipCode') zipcode: ElementRef;

  constructor(private shoppingService: ShoppingService, private helperservice: HelperService, private renderer2: Renderer2, private modalService: NgbModal,
    @Inject(DOCUMENT) private _document) {
    this.CreateAccountModel = new CreateAccountModel();
  }

  ngOnInit() {
    this.fromLocal = new UserModel();
    this.ShowZip = true;
    this.ShowInstitue = true;
    this.CreateAccountModel = new CreateAccountModel();
    this.errorInstitute = false;
    this.shoppingService.GetCountries();
    this.shoppingService.GetProvince();
    this.shoppingService.GetGraduationYears();
    this.shoppingService.observeCountries.subscribe(countries => {
      this.CountryList = countries;

      this.MsgMismatchEmail = '';
      this.MsgMismatchPassword = '';

      // tslint:disable-next-line:max-line-length
      this.CreateAccountModel.SelectedCountry = this.CountryList.find(country => country.CountryCode.toUpperCase() === appVariables.DefaultCountry);

      this.initForm();
      // this.ValiadteFields();
    });

    this.shoppingService.observeProvince.subscribe(province => {
      this.ProvinceList = Array<ProvinceModel>();
      for (const entry of province) {
        this.ProvinceList.push(new ProvinceModel(entry.ProvinceID, entry.Description));
      }
      this.Province = null;

    });

    this.shoppingService.GetProgram();
    this.shoppingService.observeProgram.subscribe(program => {
      this.ProgramList = program;
      this.ProgramID = null;
    });


    this.shoppingService.observeGraduationYears.subscribe(graduationyears => {
      this.GraduationList = graduationyears;
      this.YearsId = null;
    });

    this.InvalidZipcodeList = invalidZipcodes;
    this.subject.pipe(debounceTime(2500),distinctUntilChanged()).subscribe((CheckZipcode:any)=>
    {    
       this.OnZipcodeValue(CheckZipcode);
    })
  }

  private initForm() {
    this.registrationForm = new FormGroup({
      'Email': new FormControl(this.CreateAccountModel.Email, [Validators.required,
      // tslint:disable-next-line:max-line-length
      Validators.pattern(/^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
      // 'ReEmail': new FormControl(this.CreateAccountModel.ReEmail, [Validators.required, this.emailMatchValidator]),
      'NewPassword': new FormControl(this.CreateAccountModel.NewPassword, Validators.required),
      // 'RePassword': new FormControl(this.CreateAccountModel.RePassword, [Validators.required, this.pwdMatchValidator]),
      'FName': new FormControl(this.CreateAccountModel.FName, Validators.required),
      'LName': new FormControl(this.CreateAccountModel.LName, Validators.required),
      'SelectedCountryID': new FormControl(appVariables.CountryID.US),
      'ZipCode': new FormControl(this.CreateAccountModel.ZipCode, Validators.required),
      'SelectedProvince': new FormControl(this.CreateAccountModel.SelectedProvince),
      'OtherInstitue': new FormControl(this.CreateAccountModel.OtherInstitue),
      'SelectedInstitute': new FormControl(this.CreateAccountModel.SelectedInstitute),
      'Institute': new FormControl(null, [Validators.required]),
      'Province': new FormControl(this.CreateAccountModel.Province),
      'ProgramID': new FormControl(null, [Validators.required]),
      'GraduationYear': new FormControl(null, [Validators.required]),

      'AppId': new FormControl(this.CreateAccountModel.AppId),
      'FirstName': new FormControl(this.CreateAccountModel.FirstName),
      'LastName': new FormControl(this.CreateAccountModel.LastName),
      'Password': new FormControl(this.CreateAccountModel.Password),
      'IsActive': new FormControl(this.CreateAccountModel.IsActive),
      'InstituteID': new FormControl(this.CreateAccountModel.InstituteID),
      'InstituteName': new FormControl(this.CreateAccountModel.InstituteName),
      'CountryID': new FormControl(this.CreateAccountModel.CountryID),
      'ProvinceID': new FormControl(this.CreateAccountModel.ProvinceID),
      'AccountParentID': new FormControl(this.CreateAccountModel.AccountParentID),
      'CreateDateTime': new FormControl(this.CreateAccountModel.CreateDateTime),
      'UpdateDateTime': new FormControl(this.CreateAccountModel.UpdateDateTime),
      'LastLoginDate': new FormControl(this.CreateAccountModel.LastLoginDate),
      'AccountTypeName': new FormControl(this.CreateAccountModel.AccountTypeName)
    });

  }



  OnChangeValue(CountryCode: any) {
    if (CountryCode) {
      this.resetOnCountry();

      switch (CountryCode) {
        case appVariables.CountryID.US.toString():
          {
            this.ShowZip = true;
            this.ShowInstitue = true;
            this.ShowOtherInstitute = false;
            this.ShowProvince = false;
            this.registrationForm.controls['ZipCode'].setValidators([Validators.required]);
            this.registrationForm.controls['Institute'].setValidators([Validators.required]);
            this.registrationForm.controls['Province'].setValidators([]);
            this.registrationForm.controls['OtherInstitue'].setValidators([]);
            this.updateValidation();
            break;
          }
        case appVariables.CountryID.Canada.toString():
          {
            this.ShowZip = false;
            this.ShowOtherInstitute = false;
            this.CreateAccountModel.ZipCode = null;
            this.ShowProvince = true;
            this.ShowInstitue = true;
            this.registrationForm.controls['ZipCode'].setValidators([]);
            this.registrationForm.controls['OtherInstitue'].setValidators([]);
            this.registrationForm.controls['Province'].setValidators([Validators.required]);
            this.registrationForm.controls['Institute'].setValidators([Validators.required]);
            this.updateValidation();
            break;
          }
        default:
          {
            this.ShowZip = false;
            this.ShowInstitue = false;
            this.ShowProvince = false;
            this.CreateAccountModel.ZipCode = null;
            this.ShowOtherInstitute = true;
            this.registrationForm.controls['ZipCode'].setValidators([]);
            this.registrationForm.controls['Province'].setValidators([]);
            this.registrationForm.controls['Institute'].setValidators([]);
            this.registrationForm.controls['OtherInstitue'].setValidators([Validators.required]);
            this.updateValidation();
            break;
          }

      }
    }
  }
  updateValidation() {
    this.registrationForm.controls['ZipCode'].updateValueAndValidity();
    this.registrationForm.controls['Province'].updateValueAndValidity();
    this.registrationForm.controls['OtherInstitue'].updateValueAndValidity();
    this.registrationForm.controls['Institute'].updateValueAndValidity();
  }

  resetOnCountry() {
    this.InstituteList = null;
    this.Institute = null;
    this.errorMessage = '';
    this.errorInstitute = false;
    this.registrationForm.controls['ZipCode'].reset();
    this.registrationForm.controls['Institute'].reset();
    this.registrationForm.controls['Province'].reset();
    this.registrationForm.controls['OtherInstitue'].reset();
  }

  OnZipcodeValueChange(CheckZipcode){
   this.subject.next(CheckZipcode) ;
  }

  OnZipcodeValue(CheckZipcode) {
    this.isZipCodeValid = true;
    if(CheckZipcode!=""){
      this.InstituteList=null;
      if (this.shoppingService.IsZipcodePatternValid(CheckZipcode)) {
        if(this.InvalidZipcodeList.includes(CheckZipcode))
        {
          this.isZipCodeValid = false;
        }
        else{
      this.shoppingService.GetInstitute(CheckZipcode, 0);
      this.shoppingService.observeInstitutes.subscribe(institutes => {
        this.InstituteList = institutes;
        this.Institute = null;
        this.errorMessage = '';
        this.errorInstitute = false;
      });
      this.isZipCodeValid = true;
    }
    }
    else{
      this.isZipCodeValid = false;
    }
    if(!this.isZipCodeValid){ 
      this.errorMessage="Institution Zip Code is invalid.";
    }
  }
  else{
    this.errorMessage='';
  }
  }

  onChangeEmail(email) {
    this.shoppingService.ValidateUniqueEmail(email, 'instructor').subscribe(res => {
      if (res.Data.IsInsConfirm) {
        const modalRef = this.modalService.open(EmailAlreadyExistPopupComponent);
        modalRef.componentInstance.close = function () {
          modalRef.close();
        };
      }
    })
  }

  OnProvinceChange(CheckProvince) {
    if (CheckProvince) {
      this.shoppingService.GetInstitute(null, CheckProvince.ProvinceID);
      this.shoppingService.observeInstitutes.subscribe(institutes => {
        this.InstituteList = institutes;
        this.Institute = null;
        this.errorMessage = '';
        this.errorInstitute = false;
      });
    }
  }



  Register() {
    this.CreateAccountModel = this.registrationForm.value;
    if (!this.checkGraduationYearIsValid()) {
      return false;
    }
    this.checkExistingAccount();
    // this.checkReEmailPassword();
    if (this.MsgMismatchEmail === '' && this.MsgMismatchPassword === '' && this.InvalidEmail === false) {
      if (this.existingAccount === false) {
        this.shoppingService.CreateAccount({ ...this.registrationForm.value, "IsEmailOption": this.emailOption })
          .subscribe(
            (response) => {

              // else{
              if (response.Message === 'You have been registered successfully. Click on the confirmation mail to confirm your registration') {
                try {
                  this.fromLocal.UserName = this.CreateAccountModel.Email;
                  this.fromLocal.Password = this.CreateAccountModel.NewPassword;
                  this.studentMarketoLeadAccountDetails(this.registrationForm.value);
                } catch (e) {
                }
                this.shoppingService.logIn(this.fromLocal)
                  .subscribe(
                    (response1) => {
                      this.helperservice.setUserToLocalStorage(response1.Data);
                      this.fromLocal = this.helperservice.getUserFromLocalStorage();
                      this.shoppingService.setToken(this.fromLocal['token']);
                      if (response1['status'] === 'Invalid username/password') {
                        this.errorMessage = 'The password you entered is incorrect. Please try again or use the Forgot Password link to reset.';
                      } else {
                        let CookieVar = '';
                        // tslint:disable-next-line:max-line-length
                        let expiryDate = new Date();
                        expiryDate.setMonth(expiryDate.getMonth() + 1);
                        document.cookie = environment.CookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.fadavis.com; path=/;';
                        // tslint:disable-next-line:max-line-length
                        CookieVar += response1.Data.Email ? (!CookieVar ? 'UserName=' + response1.Data.Email : '&UserName=' + response1.Data.Email) : '';
                        CookieVar += '&AccessToken=' + '';
                        CookieVar += '&RefreshToken=' + '';
                        // tslint:disable-next-line:max-line-length
                        CookieVar += response1.Data.token ? (!CookieVar ? 'TokenId=' + response1.Data.token : '&TokenId=' + response1.Data.token) : '';
                        // tslint:disable-next-line:max-line-length
                        CookieVar += response1.Data.AccountID ? (!CookieVar ? 'AccountId=' + response1.Data.AccountID : '&AccountId=' + response1.Data.AccountID) : '';
                        CookieVar += '&AccountTypeId=' + response1.Data.AccountTypeId;
                        CookieVar += '&LastUpdated=' + new Date();
                        // tslint:disable-next-line:max-line-length
                        CookieVar += `&FullName=${response1.Data.FirstName} ${response1.Data.LastName}`;
                        document.cookie = environment.CookieName + '=' + CookieVar + ';expiryDate' + expiryDate + ';domain=.fadavis.com; path=/';

                        document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadScript(response1));
                        this.shoppingService.setDisplaySection('Login');
                        this.shoppingService.GetAddress();
                        if (this.helperservice.getFromLocalStorage(appVariables.cartGUID) !== '') {
                          this.ShoppingCart.ProductIDs = '';
                          this.ShoppingCart.ShoppingCartGUID = this.helperservice.getFromLocalStorage(appVariables.cartGUID);
                          this.shoppingService.ReconcileShoppingCartItems(this.ShoppingCart).subscribe(
                            (response2: Response) => {
                              this.helperservice.setToLocalStorage(appVariables.cartGUID, '');
                              this.shoppingService.loadItems();
                            },
                            (error) => { }
                          );
                        } else {
                          this.shoppingService.loadItems();
                          this.shoppingService.GetApplicationDetails();
                        }
                      }
                    },
                    (error) => { }
                  );
              }
              // }
            },
            (error) => { }
          );
      }
    }

  }




  pwdMatchValidator(control: FormControl) {
    // tslint:disable-next-line:max-line-length
    return ((document.getElementById('NewPassword') as HTMLInputElement).value) === ((document.getElementById('RePassword') as HTMLInputElement).value)
      ? null : { 'mismatch': true };
  }

  emailMatchValidator() {
    // tslint:disable-next-line:max-line-length
    return ((document.getElementById('Email') as HTMLInputElement).value) === ((document.getElementById('ReEmail') as HTMLInputElement).value)
      ? null : { 'mismatch': true };
  }

  checkExistingAccount() {
    const email = this.registrationForm.controls['Email'].value;
    if (email) {
        if(this.helperservice.IsEmailPatternValid(email)) {
        this.InvalidEmail = false;
        this.shoppingService.checkExistingAccount(email)
          .subscribe(
            (response) => {

              if (response.Data[0] === true) {
                this.existingAccount = true;
              } else {
                this.existingAccount = false;
              }
            }, (error) => { });
      }
      else {
        this.InvalidEmail = true;
      }
    }
  }

  checkReEmailPassword() {
    this.MsgMismatchEmail = '';
    this.MsgMismatchPassword = '';
    if (this.registrationForm.controls['Email'].value !== this.registrationForm.controls['ReEmail'].value) {
      this.MsgMismatchEmail = "'Email' and 'Confirm Email' do not match.";
    }
    if (this.registrationForm.controls['NewPassword'].value !== this.registrationForm.controls['RePassword'].value) {
      this.MsgMismatchPassword = "'Password' and 'Confirm password' do not match.";
    }
  }


  OnInstituteChange(chkInstitute) {
    if (chkInstitute) {
      // let chk=((document.getElementById("Institute") as HTMLInputElement).value);
      // tslint:disable-next-line:max-line-length
      const institute = this.registrationForm.controls['Institute'].value === null ? null : this.registrationForm.controls['Institute'].value.InstituteID;
      if (this.registrationForm.controls['Institute'].status!='INVALID' && this.registrationForm.controls['Institute'].value.InstituteID === 0) {
        this.ShowOtherInstitute = true;
        this.registrationForm.controls['OtherInstitue'].setValidators([Validators.required]);
      } else {
        this.ShowOtherInstitute = false;
      }

      const zip = this.registrationForm.controls['ZipCode'].value === null ? null : this.registrationForm.controls['ZipCode'].value;
      const province = this.registrationForm.controls['Province'].value === null ? null : this.registrationForm.controls['Province'].value;
      if (institute === null) {
        let CountryCode = this.CountryList.find(x=>x.ID==this.registrationForm.controls['SelectedCountryID'].value).CountryCode;
        if (CountryCode === "US" && !zip) {
          this.errorMessage = 'Institution Zip code is required for this selection.';
          this.errorInstitute = true;
        } else if (CountryCode === "CA" && !province) {
          this.errorMessage = 'Province is required for this selection.';
          this.errorInstitute = true;
        }
      } else {
        this.errorMessage = '';
        this.errorInstitute = false;
      }
    }
  }


  chkInvalidControl() {
    const invalid = [];
    const controls = this.registrationForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;

  }
  checkGraduationYearIsValid() {
    let year = Number(this.registrationForm.controls['GraduationYear'].value)
    if (year >= 1900 && year <= 2070) {
      this.invalidGraduationYear = ``;

      return true;
    }
    else {
      this.invalidGraduationYear = appMessages.invalidGraduationYear;
      return false;
    }
  }
  OnEmailCheckClick(Checkevent) {
    this.emailOption = Checkevent.target ? Checkevent.target.checked : Checkevent;
  }
  public onlyNumericValue(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
    }
  }
  studentMarketoLeadAccountDetails(account) {
    marketoLeadAccountDetails.PostalCode = "N/A";
    marketoLeadAccountDetails.accountProvince = "N/A";
    let instituteName = (account.Institute) ? account.Institute.InstituteName : "N/A";
    if (this.ShowZip) {
      marketoLeadAccountDetails.PostalCode = account.ZipCode;
    }

    if (this.ShowProvince) {
      marketoLeadAccountDetails.accountProvince = (account.Province) ? account.Province.Description : 'N/A';
    }
    if (this.ShowOtherInstitute) {
      marketoLeadAccountDetails.schoolOrganizationUnlisted = instituteName;
      marketoLeadAccountDetails.schoolOrganization = account.OtherInstitue;
    } else {
      marketoLeadAccountDetails.schoolOrganization = instituteName;
    }

    marketoLeadAccountDetails.Email = account.Email;
    marketoLeadAccountDetails.FirstName = account.FName;
    marketoLeadAccountDetails.LastName = account.LName;
    marketoLeadAccountDetails.Country = this.CountryList.find(a => a.ID == account.SelectedCountryID).Name;
    marketoLeadAccountDetails.d2SGraduationYear = account.GraduationYear;
    marketoLeadAccountDetails.d2SProgram = this.ProgramList.find((d) => d.ProgramID == account.ProgramID).Description;
    marketoLeadAccountDetails.emailPreference = this.emailOption;
    console.log(`marketoLeadAccountDetails:`, marketoLeadAccountDetails);
    this.postMarketoLeads(marketoLeadAccountDetails)

  }

  postMarketoLeads(account) {
    const s = this.renderer2.createElement('script');
    s.onload = this.loadNextScript.bind(this, account);
    s.type = 'text/javascript';
    s.src = '//app-ab35.marketo.com/js/forms2/js/forms2.min.js';
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);

  }
  loadNextScript(account) {
    if (this.marketoJSObject) {
      this.renderer2.removeChild(this._document.body, this.marketoJSObject);
    }
    let accountData = JSON.stringify(account);
    this.marketoJSObject = this.renderer2.createElement('script');
    this.marketoJSObject.text = `
    MktoForms2.loadForm("${environment.MarketoLeadFormUrl}", "${environment.MarketoLeadMunchkinId}", ${environment.MarketoLeadFormId});

    MktoForms2.whenReady(function (form) {

      //the addHiddenFields methods lets us add arbitrary fields to the form as well as their values
      form.addHiddenFields(${accountData});

      //submit the form
      form.submit();
      form.onSuccess(function (vals, url) {
        localStorage.setItem("marketoResponse", JSON.stringify(vals));
        localStorage.setItem("marketoRequest", JSON.stringify(${accountData}));
        console.log("submitted Values -",vals);
        console.log(form.getId(),form.getValues());
        return false;

      });

    });
    `;
    this.renderer2.appendChild(this._document.body, this.marketoJSObject);
    let intervalid = setInterval(() => {

      this.shoppingService.LogMarketoLeadData().subscribe(
        (response: any) => {
          localStorage.removeItem('marketoRequest');
          localStorage.removeItem('marketoResponse');
        })
      clearInterval(intervalid);

    }, 100);
  }
  onValidateName(event: any) {
    var input = String.fromCharCode(event.keyCode);
    if (!this.helperservice.validateName(input)) {
      event.preventDefault();
      return false;
    }
    else {
      return true;
    }
  }
  ngOnDestroy() {

    if (this.marketoJSObject) {
      this.renderer2.removeChild(this._document.body, this.marketoJSObject);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/create-account/create-account.component.ts